import { useLastNonNull } from "@lib/Hooks"
import { labelForWorkRequest, WorkRequest } from "@model/workRequests/WorkRequest"
import { Button, ButtonType } from "@ui/common/buttons/Button"
import { Grid } from "@ui/common/grids/Grid"
import { Modal, ModalBody, ModalButtons, ModalContent, ModalHeader, ModalHeaderTitle } from "@ui/common/Modal"
import React from "react"

export function RemoveWorkRequestModal({
    workRequest,
    onCancel,
    onConfirm,
    removeTerminology,
    removeVerbTerminology,
    itemDescriptionTerminology,
    customMessage,
}: {
    workRequest: WorkRequest | null
    onCancel: () => void
    onConfirm: (WorkRequest: WorkRequest) => void
    removeTerminology?: string | null
    removeVerbTerminology?: string | null
    itemDescriptionTerminology?: string | null
    customMessage?: string | null
}): JSX.Element {
    const removeTerm = removeTerminology ?? "Remove"
    const removeVerbTerm = removeVerbTerminology ?? "Removing"
    const itemTerm = itemDescriptionTerminology ?? "Service Request"
    const itemTermPlural = itemDescriptionTerminology ? `${itemDescriptionTerminology}s` : "Service Requests"
    const data = useLastNonNull(workRequest)
    if (data === null) return <Modal isVisible={workRequest !== null} />

    return (
        <Modal isVisible={workRequest !== null} useContentTag={true} onClose={onCancel}>
            <ModalContent>
                <ModalHeader>
                    <ModalHeaderTitle>{removeTerm} {itemTerm}</ModalHeaderTitle>
                </ModalHeader>
                <ModalBody>
                    <Grid columns={1}>
                        <div>
                            {customMessage ? customMessage :
                                <>
                                    Are you sure you wish to {removeTerm.toLowerCase()} the following {itemTerm} from this Work Order? {removeVerbTerm} a {itemTerm} from a Work order will return it to the queue of {itemTermPlural.toLowerCase()}.
                                </>
                            }
                        </div>
                        <i>{labelForWorkRequest(data)}</i>
                    </Grid>
                </ModalBody>
                <ModalButtons>
                    <Button label="Cancel" type={ButtonType.Text} onClick={onCancel} />
                    <Button label={`${removeTerm} ${itemTerm}`} onClick={() => onConfirm(data)} />
                </ModalButtons>
            </ModalContent>
        </Modal>
    )
}
